import { IoLogoYoutube } from 'react-icons/io';
import styled from '@emotion/styled';
import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 유튜브 새창 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScYoutube({ color }: Props): JSX.Element {
  const onClick = (): void => {
    window.open('https://www.youtube.com/channel/UC_pqMlpJIwZIoXj6o9-0kcQ');
  };

  return (
    <Button onClick={onClick}>
      <IoLogoYoutube size={28} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScYoutube;
